import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/lib/useLenis";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Owners from "@/pages/Owners";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import LongTermStays from "@/pages/LongTermStays";
import Cleaning from "@/pages/Cleaning";
import Book from "@/pages/Book";
import Pay from "@/pages/Pay";
import GuestVerify from "@/portal/GuestVerify";
import LuxuryVacationHomes from "@/pages/LuxuryVacationHomes";
import FurnishedPrivateHomes from "@/pages/FurnishedPrivateHomes";
import PortalHub from "@/portal/PortalHub";
import PortalActivate from "@/portal/PortalActivate";
import { PortalAuthProvider } from "@/portal/PortalAuth";
import {
  GuestLogin, ManagementLogin, HomeownerLogin,
  GuestProtected, ManagementProtected, HomeownerProtected,
} from "@/portal/routes";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = ({ children }) => {
  useLenis();
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <PortalAuthProvider>
        <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:slug" element={<PropertyDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/owners" element={<Owners />} />
          <Route path="/long-term-stays" element={<LongTermStays />} />
          <Route path="/luxury-vacation-homes" element={<LuxuryVacationHomes />} />
          <Route path="/furnished-private-homes" element={<FurnishedPrivateHomes />} />
          <Route path="/book" element={<Book />} />
          <Route path="/pay/:id" element={<Pay />} />
          <Route path="/cleaning-services" element={<Cleaning />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/portal" element={<PortalHub />} />
          <Route path="/portal/activate" element={<PortalActivate />} />
          <Route path="/guest" element={<GuestLogin />} />
          <Route path="/guest/verify" element={<GuestVerify />} />
          <Route path="/guest/dashboard" element={<GuestProtected />} />
          <Route path="/management" element={<ManagementLogin />} />
          <Route path="/management/dashboard" element={<ManagementProtected />} />
          <Route path="/homeowner" element={<HomeownerLogin />} />
          <Route path="/homeowner/dashboard" element={<HomeownerProtected />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" />
      </PortalAuthProvider>
    </BrowserRouter>
  );
}

export default App;
